<template>
    <div
      class="map"
      id="home-map"
    >
    </div>
</template>

<script>
import '@/assets/leaflet/leaflet-src.js'
import '../../cb/leaflet/leaflet.svgicon.js'
import '../../cb/leaflet/leaflet-cyclone.js'
import '../../cb/leaflet/leaflet.cyclone-radius.js'
import '@/assets/js/sprintf.min.js'
import '@/assets/js/cb.date.js'
import mdmvUrl from '../../cb/wind-js/mdmv-worker.js?url'
import windyUrl from '../../cb/wind-js/windy.js?url'
import windyProxyUrl from '../../cb/leaflet-windy/windy-layer-worker.js?url'
import windCanvasUrl from '../../cb/leaflet-windy/L.WindCanvas.js?url'
import windyLayerUrl from '../../cb/leaflet-windy/L.WindyLayer.js?url'

import {
    ANIMATE_TIME,
    INTERVAL_TIME,
    DTG_LIST
} from '@/assets/js/cbweb.settings.js'

import {
    trackData,
    pastData,
    iconCase,
    pointInterpolation
} from '@/assets/js/track.js'

import {
    WindyOption
} from '@/assets/js/windy.settings.js'

import { TcSpotHandler } from '@/assets/js/tc_spot.js'

const L = globalThis.L

function loadScript(src) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script')
        script.src = src
        script.onload = resolve
        script.onerror = reject
        document.head.appendChild(script)
    })
}

L.Icon.Default.imagePath = '../src/assets/leaflet/images/'


export default {

    data () {
        return {
            map: null,
            hourly_points: []
        }
    },

    methods: {
        init_map () {
            this.map = L.map("home-map", {
                minZoom: 5,
                maxZoom: 5,
                center: [22, 130], // 目前的tile和真實地理位置[20, 120] 差了約 [0, 6] 度
                zoom: 5,
                zoomControl: false,
                maxBounds: [[80, 80], [-10, 180]],
                layers: [
                    L.tileLayer('/maptiles/{z}/{x}/{y}.jpg')
                ]
            })

            this.map.attributionControl.setPrefix('')
        },

        init_track () {
            this.past = new L.Cyclone.Track(pastData, {
                markerOptions: {
                    iconCase: iconCase
                },
                color: '#fff',
                weight: 2,
                markerVisible: true,
                radiusVisible: false
            }).addTo(this.map)

            this.track = new L.Cyclone.Track(trackData, {
                markerOptions: {
                    iconCase: iconCase,
                    radius: {
                        r7: {weight: 1, color: '#fa0', great_circle: true},
                        r10: {weight: 1, color: '#f00', great_circle: false},
                    }
                },
                color: '#ff977b',
                dashArray: [5, 5],
                weight: 2,
                markerVisible: true,
                radiusVisible: false
            }).addTo(this.map)
        },

        init_spotlight () {
            this.hourly_points = pointInterpolation(trackData.points)

            this.spot_handler = new TcSpotHandler(this.map, "201807191200")
            this.spot_handler.set_tracks(this.hourly_points)
            this.spot_handler.set_dtg("201807191200")
        },

        init_windy_layer () {
            this.windy_layer = L.windyLayer(WindyOption).addTo(this.map)

            this.windy_proxy = new WindyDataProxy(this.windy_layer)
            this.windy_proxy.goto_dtg("/noaa_201807191200-000.json")
        },

        animate (animate_time) {

            let self = this

            function sleep (time) {
                return new Promise((resolve) => setTimeout(resolve, time));
            }

            DTG_LIST.forEach((dtg, idx) => {
                let sleep_time = (idx + 1) * animate_time
                let grib_uri = "/noaa_" + dtg + "-000.json"

                sleep(sleep_time).then(() => {
                    self.windy_proxy.goto_dtg(grib_uri)
                    self.spot_handler.set_dtg(dtg)
                })
            })
        }
    },

    async mounted () {
        await loadScript(mdmvUrl)
        await loadScript(windyUrl)
        await loadScript(windyProxyUrl)
        await loadScript(windCanvasUrl)
        await loadScript(windyLayerUrl)

        WindyOption.worker_uri = mdmvUrl

        this.init_map()
        this.init_track()

        this.init_spotlight()
        this.init_windy_layer()

        this.animate(ANIMATE_TIME)

        setInterval(()=> {
            this.animate(ANIMATE_TIME)
        }, INTERVAL_TIME)

    }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
    @import "../assets/leaflet/leaflet.css";
</style>
